/* jshint esversion: 6 */
import React, { useEffect, useRef, useState } from 'react';
import WelcomeDialog from '@/shadcn/components/account/PlanChange/WelcomeDialog.tsx';
import { useConfirmationStep } from './useChangePreview.js';

/*
 * Opens through the legacy modal stack once a paid plan starts: from SubscriptionNew
 * for a new subscriber, and from Subscription.jsx (`returning`) for one coming back.
 * `planLevel` is the new plan;
 * `confirmationAction` carries on to wherever the caller sends the user next, and runs
 * for both keeping the current speed and finishing.
 *
 * "Check every N minutes" sets every active source to the plan's fastest check
 * (SUB_UPDATE_PULL_FREQ); plans.updatedPullFreq counts up when that lands.
 */
export default function WelcomeConfirm(props) {
    const { app, plans, planLevel, returning } = props,
        detail = plans.details[planLevel],
        updated = plans.updatedPullFreq,
        [speed, setSpeed] = useState('offered'),
        updatedBefore = useRef(updated),
        wasUpdating = useRef(false),
        updating = app.loading.SUB_UPDATE_PULL_FREQ;

    // the funnel doesn't count a brand new subscriber's welcome as its confirmation step
    useConfirmationStep(!!returning);

    useEffect(() => {
        if (wasUpdating.current && !updating) {
            setSpeed(updated > updatedBefore.current ? 'updated' : 'offered');
        }
        wasUpdating.current = updating;
    }, [updating, updated]);

    if (!detail || !detail.limits || app.loading.SUB_FETCH_DETAIL) {
        return null;
    }

    // Basic and Starter have no faster speed to offer a new subscriber
    const offersSpeed = returning || (!props.isBasicUser(planLevel) && !props.isStarterUser(planLevel)),
        postLimit = parseInt(detail.limits.postLimit, 10) || 0;

    return (
        <WelcomeDialog
            returning={!!returning}
            label={detail.label}
            fastest={offersSpeed ? parseInt(detail.limits.pullFrequencyList?.[0], 10) || null : null}
            limits={{
                inputs: parseInt(detail.limits.hardLimitInputs, 10),
                outputs: parseInt(detail.limits.hardLimitOutputs, 10),
                postLimit
            }}
            speed={updating ? 'updating' : speed}
            onSpeedUp={() => {
                props.updatePullFreq();
            }}
            onDone={() => props.confirmationAction()}
            onClose={() => props.closeAllModals()} />
    );
}
